export const POSITIVE_IMPACT_OPTIONS = [
  { value: 1, label: "Minor", description: "A small help" },
  { value: 2, label: "Moderate", description: "Noticeably helped my progress" },
  { value: 3, label: "Significant", description: "Had a major effect on my workflow" },
  { value: 4, label: "Transformative", description: "Completely solved my problem" },
] as const;

export const NEGATIVE_IMPACT_OPTIONS = [
  { value: 1, label: "Minor", description: "A small hiccup" },
  { value: 2, label: "Moderate", description: "Noticeably hindered my progress" },
  { value: 3, label: "Significant", description: "Had a major effect on my workflow" },
  { value: 4, label: "Transformative", description: "Completely blocked me" },
] as const;

export const POSITIVE_IMPACT_LABELS: Record<number, string> = Object.fromEntries(
  POSITIVE_IMPACT_OPTIONS.map((o) => [o.value, o.label])
);

export const NEGATIVE_IMPACT_LABELS: Record<number, string> = Object.fromEntries(
  NEGATIVE_IMPACT_OPTIONS.map((o) => [o.value, o.label])
);
